import { Box, Button, Grid2, Typography } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import AddAPhotoOutlinedIcon from "@mui/icons-material/AddAPhotoOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import surveyImage from "../assets/survey image.png";
import ComingSoonModal from "./ComingSoonModal";

const DashboardHome = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <Box className="parent-div">
      <Header heading={"Home"}></Header>

      <Box
        sx={{ display: "flex", flexDirection: "column", flex: 1 }}
        className="main-container"
      >
        <Grid2
          container
          sx={{ textAlign: "center" }}
          columnSpacing={2}
          rowSpacing={2}
        >
          <Grid2 size={{ xs: 6 }} className="box-option">
            <Link to={"/dashboard/active-surveys"}>
              <Box sx={{ color: "#BEA800", fontWeight: 600 }}>
                <img src={surveyImage} alt="" width={40} />
                <Typography>Take Survey</Typography>
              </Box>
            </Link>
          </Grid2>
          <Grid2 size={{ xs: 6 }} className="box-option">
            <Link>
              <Box sx={{ color: "#BEA800", fontWeight: 600 }} onClick={handleOpen}>
                <AddAPhotoOutlinedIcon fontSize="large" />
                <Typography>Upload Bill</Typography>
              </Box>
            </Link>
          </Grid2>
          <Grid2 size={{ xs: 6 }} className="box-option">
            <Link to={"/dashboard/survey-points"}>
              <Box
                sx={{
                  color: "#64748B",
                  fontWeight: 500,
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <EmojiEventsOutlinedIcon />
                Survey Points
              </Box>
            </Link>
          </Grid2>
          <Grid2 size={{ xs: 6 }} className="box-option">
            <Link>
              <Box
                sx={{
                  color: "#64748B",
                  fontWeight: 500,
                  fontSize: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={handleOpen}
              >
                <WorkspacePremiumOutlinedIcon />
                Upload Bill Points
              </Box>
            </Link>
          </Grid2>
        </Grid2>
      </Box>
      <ComingSoonModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
    </Box>
  );
};

export default DashboardHome;
